import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CalendarDays, MessageCircle } from 'lucide-react';
import { BOOKING_URL } from '@/config/site';

function toggleMobileChat() {
  window.dispatchEvent(new CustomEvent('toggle-chat-bubble'));
}

export default function MobileBottomBar() {
  const location = useLocation();
  const [hideOnHomeHero, setHideOnHomeHero] = useState(false);
  const [hideForMobileMenu, setHideForMobileMenu] = useState(false);

  useEffect(() => {
    if (location.pathname !== '/') {
      setHideOnHomeHero(false);
      return;
    }

    const updateVisibility = () => {
      const heroSection = document.querySelector('[data-testid="hero-section"]');
      if (!heroSection) {
        setHideOnHomeHero(false);
        return;
      }

      const heroRect = heroSection.getBoundingClientRect();
      const shouldHideBar = heroRect.bottom > window.innerHeight * 0.55;
      setHideOnHomeHero(shouldHideBar);
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);

    return () => {
      window.removeEventListener('scroll', updateVisibility);
      window.removeEventListener('resize', updateVisibility);
    };
  }, [location.pathname]);

  useEffect(() => {
    const syncFromBody = () => {
      setHideForMobileMenu(document.body.dataset.mobileMenuOpen === 'true');
    };

    const handleMenuState = (event) => {
      setHideForMobileMenu(Boolean(event.detail?.open));
    };

    syncFromBody();
    window.addEventListener('mobile-menu-state', handleMenuState);
    return () => {
      window.removeEventListener('mobile-menu-state', handleMenuState);
    };
  }, []);

  return (
    <div
      data-testid="mobile-bottom-bar"
      className={`fixed bottom-0 left-0 right-0 z-50 border-t border-stone-200 glass transition-all duration-300 md:hidden ${
        hideOnHomeHero || hideForMobileMenu ? 'pointer-events-none translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <div className="flex items-center justify-between px-4 py-3 gap-2">
        {/* Booking - Primary */}
        <a
          href={BOOKING_URL}
          data-testid="mobile-book-btn"
          className="hero-book-premium inline-flex flex-1 items-center justify-center gap-2"
        >
          <CalendarDays size={18} strokeWidth={1.5} />
          <span>Book My Visit</span>
        </a>

        {/* Live Chat - Secondary */}
        <button
          type="button"
          onClick={toggleMobileChat}
          data-testid="mobile-chat-btn"
          className="flex items-center justify-center gap-2 rounded-full border border-stone-300 bg-white py-3 px-4 font-body text-sm font-medium text-charcoal transition-all hover:border-stone-400 hover:bg-stone-50 active:scale-[0.98]"
        >
          <MessageCircle size={18} strokeWidth={1.5} />
          <span>Let's Talk</span>
        </button>
      </div>
    </div>
  );
}
